import { CodeBase } from "./_codeBase";

/** 立会作業操作区分*/
export class AttendantWorkOperationDiv extends CodeBase<AttendantWorkOperationDiv>
{
    /** 立会作業操作区分: "01", "操作制限なし"*/
    public static readonly OPERATIONNONLIMIT: AttendantWorkOperationDiv = new AttendantWorkOperationDiv("01", "操作制限なし", "");

    /** 立会作業操作区分: "02", "操作制限有り"*/
    public static readonly OPERATIONLIMIT: AttendantWorkOperationDiv = new AttendantWorkOperationDiv("02", "操作制限有り", "○");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): AttendantWorkOperationDiv[] {
        return [
            AttendantWorkOperationDiv.OPERATIONNONLIMIT,
            AttendantWorkOperationDiv.OPERATIONLIMIT,
        ];
    }
}
